// aos-observer.js — Lightweight AOS replacement using IntersectionObserver
// Replaces the AOS library (~15KB) with ~40 lines
(function() {
  'use strict';

  const ANIMATIONS = {
    'fade-up': { from: { opacity: '0', transform: 'translate3d(0, 30px, 0)' },
                 to:   { opacity: '1', transform: 'translate3d(0, 0, 0)' } },
    'fade':    { from: { opacity: '0' },
                 to:   { opacity: '1' } },
    'fade-down': { from: { opacity: '0', transform: 'translate3d(0, -30px, 0)' },
                   to:   { opacity: '1', transform: 'translate3d(0, 0, 0)' } },
    'fade-left': { from: { opacity: '0', transform: 'translate3d(30px, 0, 0)' },
                   to:   { opacity: '1', transform: 'translate3d(0, 0, 0)' } },
    'fade-right': { from: { opacity: '0', transform: 'translate3d(-30px, 0, 0)' },
                    to:   { opacity: '1', transform: 'translate3d(0, 0, 0)' } },
  };

  const DURATION = 600;
  const EASING = 'cubic-bezier(0.16, 1, 0.3, 1)';

  function initAOS() {
    const elements = document.querySelectorAll('[data-aos]');
    if (!elements.length) return;

    elements.forEach(el => {
      const type = el.getAttribute('data-aos');
      const anim = ANIMATIONS[type];
      if (!anim) return;
      Object.assign(el.style, anim.from);
      el.style.transition = 'none';
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const type = el.getAttribute('data-aos');
        const delay = parseInt(el.getAttribute('data-aos-delay') || '0', 10);
        const anim = ANIMATIONS[type];
        if (!anim) return;

        setTimeout(() => {
          el.style.transition = `opacity ${DURATION}ms ${EASING}, transform ${DURATION}ms ${EASING}`;
          Object.assign(el.style, anim.to);
          // Clear inline styles after animation so they don't interfere with click/interaction
          setTimeout(() => {
            el.style.opacity = '';
            el.style.transform = '';
            el.style.transition = '';
            el.style.transitionDelay = '';
            el.style.animationDelay = '';
            el.classList.add('aos-animate');
          }, DURATION + 50);
        }, delay);

        observer.unobserve(el);
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    elements.forEach(el => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAOS);
  } else {
    initAOS();
  }

  window.refreshAOS = function() {
    initAOS();
  };

  // AOS compatibility — many sections call AOS.init() / AOS.refreshHard() after adding data-aos attributes
  window.AOS = {
    init: function() { initAOS(); },
    refresh: function() { initAOS(); },
    refreshHard: function() { initAOS(); }
  };
})();
